// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = require('./_export');

$export($export.S, 'Array', { isArray: require('./_is-array') });



//////////////////
// WEBPACK FOOTER
// D:/ENI Project/Trunk/AngularSourceCode/ENI.BalanceBenefits.WebPortal/~/core-js/modules/es6.array.is-array.js
// module id = ../../../../core-js/modules/es6.array.is-array.js
// module chunks = 2